//import { apibaseURL } from "../../config"
//import { getCookie } from "../helper/Helper";
import {getCurrentUserData,checkLoggedInUser} from "../../services/http-services/HttpServices";
import {apibaseURL,eStoragebaseURL, errorMessage,LOGOUT,RESET_DOCKET_DATA} from "../../config";
import { getCookie, deleteCookie, history } from "../../services/helper/Helper";

export function authenticate(data) {
	return fetch(
		apibaseURL+"authenticate",
		{method: 'POST',headers: { 'Content-Type': 'application/json' },body: JSON.stringify(data)}
	)
	.then(response => response.json())
}

const asyncCall = async () =>  {
	//console.log('calling');
	const result = await getCurrentUserData();
	return result;
}

export  async function isAuthenticated() {
	//let value=getCookie(btoa("publicAccess"));
	//return value?JSON.parse(atob(value)).user_id:false;
	// let user_id = '';
	// user_id = getCurrentUserData()
	// 		.then(json => {
	// 			user_id = json.user_id;
	// 		});
	// 		return user_id?user_id:false;

			let userData = await asyncCall();
			//console.log(userData,5400);
			if(userData == 'undefined' || !userData || userData == false || userData.code == 401 || userData.code == '401')
			{
				//console.log(userData,'inside false conditiion',1200);
				if(deleteCookie(btoa("publicAccess")) && deleteCookie(btoa("TAWAJ"))){
				history.push('/login');
				//   dispatch(userLogout())
				//   dispatch({type:RESET_DOCKET_DATA})
				}
				return false;
			}
			//console.log(userData,'outside false conditiion',5000);
			let user_id = userData.user_id;
			return user_id?user_id:false;
}

export  async function isCheckedLoggedInUser() {
			const result = await asyncCallLoggedInUser();
			return result;
}

const asyncCallLoggedInUser = async () =>  {
	//console.log('calling');
	const result = await checkLoggedInUser();
	console.log(result,707070);
	return result;
}

